import { Dialog } from '@angular/cdk/dialog';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IWorkspaceDetails } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { ConfirmationPopupWithFormComponent } from 'libs/shared/ui-components/src/lib/confirmation-popup-with-form/confirmation-popup-with-form.component';

@Component({
  selector: 'app-workspace-details',
  templateUrl: './workspace-details.component.html',
  styleUrls: ['./workspace-details.component.scss']
})
export class WorkspaceDetailsComponent {
  constructor(
    private commonHttpService: CommonHttpService,
    private route: ActivatedRoute,
    private router: Router,
        private dialog: Dialog,
  ) { }
  workspaceId = this.route.snapshot.paramMap.get('workspaceId');
  loaderView: boolean = true;
  workspaceDetails: IWorkspaceDetails | null = null;
  attributeDetails: any;
  groupedConfigs: { [key: string]: any[] } = {};
  editFormData: any;
  payload: any;
  assetDetails: any;
  attributeMap: any ={};
  plan:any=[];
  loadingCount = 0;
  ngOnInit() {
    this.loaderView = true;
    this.getWorkspaceDetails(this.workspaceId);
    this.getUserAttributes(this.workspaceId);
    this.assetDetails = {
      categories: [
        { name: 'Employee Type', displayName: 'Employee Type' },
        { name: 'Employee Status', displayName: 'Employee Status' },
        { name: 'Employee Designation', displayName: 'Employee Designation' }
      ],
      configs: [
        {
          category: 'Employee Type',
          displayName: 'empType',
          values: [],
          list: false
        },
        {
          category: 'Employee Status',
          displayName: 'empStatus',
          values: [],
          list: false
        },
        {
          category: 'Employee Designation',
          displayName: 'designation',
          values: [],
          list: true
        }
      ]
    };
    this.groupConfigsByCategory();
  }
  startLoading() {
  this.loadingCount++;
  this.loaderView = true;
}

stopLoading() {
  this.loadingCount--;
  if (this.loadingCount === 0) {
    this.loaderView = false;
  }
}
  getAttributeValues(attribute: string){
    const values: string[] =[];
    this.attributeDetails.forEach((att: any)=>{
      if(att.attributeName === attribute){
        values.push(att.attributeValue)
      }
    })
    return values.join(', ');
  }
  getWorkspaceDetails(workspaceId: any) {
    this.startLoading();
    setTimeout(() => {
    this.commonHttpService.getWorkspaceDetails(workspaceId).subscribe({
      next: (response: any) => {
        const workspaceDetailsData = Object(response).data as IWorkspaceDetails;
        this.workspaceDetails = workspaceDetailsData;
        this.plan = workspaceDetailsData.plan
        this.stopLoading();
      },
      error: (error) => {
        this.stopLoading();
      }
    });
  });
  }
  getAcronyms(acronyms: any) {
    return acronyms[0]
  }
  getUserAttributes(worspaceId: any) {
    this.startLoading();
    this.commonHttpService.getUserAttributes(worspaceId).subscribe({
      next: (response: any) => {
        this.attributeDetails = response.data;
        this.stopLoading();
      }
    })
  }
  handleCancel() {
    this.router.navigate(['home/main/dashboard'])
  }
  handleEdit(form: string){
    this.router.navigate(['home/main/edit-workspace', this.workspaceId], 
      {state:{form: form}});
  }
  groupConfigsByCategory() {
    this.groupedConfigs = {};
    this.assetDetails.configs.forEach((config: any) => {
      if (!this.groupedConfigs[config.category]) {
        this.groupedConfigs[config.category] = [];
      }
      this.groupedConfigs[config.category].push(config);
    });
  }
 onEditConfig(categoryName: string, configIndex: number): void {
     const attributeNameMap: Record<string, string> = {
   "Employee Status": "empStatus",
   "empStatus": "empStatus",
   "Employee Type": "empType",
   "empType": "empType",
   "Employee Designation": "designation",
   "designation": "designation"
 };
 const normalizedName = attributeNameMap[categoryName] || categoryName;
 const prefilledValue = this.getAttributeValues(normalizedName) || '';
//  const prefilledValue = this.attributeMap[normalizedName]?.value || '';
     const config = this.groupedConfigs[categoryName][configIndex];
     this.editFormData = {
       header: `Edit ${categoryName}`,
       description: `Modify values for ${categoryName}`,
       image: 'editImage',
       form: {
         confirmationForm: new FormGroup({
           property: new FormControl({ value: config.displayName, disabled: true }),
           value: new FormControl(prefilledValue, Validators.required),
         }),
       },
       includeUnits: false,
       includeIsRequired: false,
       fields: [
         {
           field: 'text-fields',
           controlName: 'value',
           placeholder: `E.g. ${categoryName === 'Employee Type' ? 'On Probation' : categoryName === 'Employee Status' ? 'Active' : 'Intern'}`,
           label: 'Value(s)',
         },
       ],
       primaryBtn: 'Save',
       showAddButton: false
     };
 
     const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
       panelClass: 'center-dialog-box',
       backdropClass: 'backdrop',
       disableClose: true,
       width: '50%',
       data: this.editFormData
     });
 
     dialogRef.closed.subscribe((result: any) => {
       if (result) {
         const newValues = result.value
           ? result.value.map((v: string) => v.trim()).filter((v: string) => v.length > 0)
           : [];
 
         this.groupedConfigs[categoryName][configIndex].values = newValues;
         const globalIndex = this.assetDetails.configs.findIndex(
           (c: any) => c.category === categoryName && c.displayName === config.displayName
         );
 
         if (globalIndex !== -1) {
           this.assetDetails.configs[globalIndex].values = newValues;
         }
         
         this.payload = {
           workspaceId: this.workspaceId,
           attributes: [
             ...Object.entries(this.groupedConfigs)
               .flatMap(([category, configs]) =>
                 configs
                   .map(cfg => ({
                     attributeName: cfg.displayName,
                     attributeValues: [...this.attributeMap[cfg.category].value] 
                   }))
               )
           ]
         };
       }
     });
   }
}
